import React, { Component } from 'react';
import Modal from 'react-modal';
import Slider from 'react-slick';

const customStyles = {
    content : {
        top: '75px',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translateX(-50%)',
        padding: '0',
        margin: '0',
        width: '95%',
        maxWidth: '700px',
        borderRadius: 0,
        border: 0,
    },
    overlay: {
        background: 'rgba(255, 255, 255, 0.95)'
    }
};

const settings = {
    slidesToShow: 4,
    arrows: false,
    dots: true,
    infinite: false,
    responsive: [
        {
            breakpoint: 599,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 399,
            settings: {
                slidesToShow: 1
            }
        },
    ]
}

class FounderTales extends Component {
    state = {
        video: false,
    }

    render() {
        return(
            <div className="block founder-tales row">
                <div className="col-sm-12">
                    <div className="founder-tales__inner">
                        <a
                            href={'https://www.youtube.com/channel/UCOWmqbuXZUBCogH4YT7q0rA'}
                            target={'_blank'}
                            className="block__heading"
                        >
                            <h5 className="block__title">Founder Tales</h5>

                            <div className="block__heading__content">
                                <p>The best people to learn from are those still going and still growing, we find them and share their lessons through Founder Tales</p>
                            </div>
                        </a>

                        <Slider
                            {...settings}
                            className="founder-tales__items"
                        >
                            <div
                                className="video-thumbnail"
                                key={`founder-victoria`}
                            >
                                <div className="video-thumbnail__cover">
                                    <button
                                        onClick={() => this.setState({ video: 'v_PtMvp7SqU' })}
                                    >
                                        <img src="/img/founder-tales/victoria-mann.png" alt="Watch Victoria's Founder Tales interview"/>
                                    </button>
                                </div>

                                <button
                                    onClick={() => this.setState({ video: 'v_PtMvp7SqU' })}
                                    className="video-thumbnail__caption"
                                >
                                    <p>Victoria Mann</p>
                                    <p>Near Me Now</p>
                                </button>
                            </div>

                            <div
                                className="video-thumbnail"
                                key={`founder-paul`}
                            >
                                <div className="video-thumbnail__cover">
                                    <button
                                        onClick={() => this.setState({ video: '_ovYKau07KU' })}
                                    >
                                        <img src="/img/founder-tales/paul-sheperd.png" alt="Watch Paul's Founder Tales interview"/>
                                    </button>
                                </div>

                                <button
                                    onClick={() => this.setState({ video: '_ovYKau07KU' })}
                                    className="video-thumbnail__caption"
                                >
                                    <p>Paul Sheperd</p>
                                    <p>Coup Media</p>
                                </button>
                            </div>

                            <div
                                className="video-thumbnail"
                                key={`founder-aimee`}
                            >
                                <div className="video-thumbnail__cover">
                                    <button
                                        onClick={() => this.setState({ video: '1z0M0-tTaMc' })}
                                    >
                                        <img src="/img/founder-tales/aimee-bateman.png" alt="Watch Aimee's Founder Tales interview"/>
                                    </button>
                                </div>

                                <button
                                    onClick={() => this.setState({ video: '1z0M0-tTaMc' })}
                                    className="video-thumbnail__caption"
                                >
                                    <p>Aimee Bateman</p>
                                    <p>careercake.com</p>
                                </button>
                            </div>

                            <div 
                                className="video-thumbnail"
                                key={`founder-nicholas`}
                            >
                                <div className="video-thumbnail__cover">
                                    <button
                                        onClick={() => this.setState({ video: 'eEyPgg7Lrw4' })}
                                    >
                                        <img src="/img/founder-tales/nicholas-fearn.png" alt="Watch Nicholas' Founder Tales interview"/>
                                    </button>
                                </div>

                                <button
                                    onClick={() => this.setState({ video: 'eEyPgg7Lrw4' })}
                                    className="video-thumbnail__caption"
                                >
                                    <p>Nicholas Fearn</p>
                                    <p>Tech Dragons</p>
                                </button>
                            </div>
                        </Slider>
                    </div>
                </div>

                <Modal
                    isOpen={this.state.video}
                    onRequestClose={() => this.setState({ video: false })}
                    style={customStyles}
                >
                    <div className="modal-vid">
                        <iframe width="560" height="315" src={`https://www.youtube.com/embed/${this.state.video}`} frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen />
                    </div>
                </Modal>
            </div>
        );
    }
}

export default FounderTales;



// WEBPACK FOOTER //
// ./src/js/components/FounderTales.js